import PropTypes from 'prop-types'
import _ from 'lodash'
import createReactClass from 'create-react-class'

import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import Select from 'legacy/libs/components/select'
import expertApi from 'legacy/api/expert'
import { getFullName } from 'legacy/account/utils'

import { GetText } from 'lib/gettext'

export default createReactClass({
  displayName: 'ChooseExpert',

  mixins: [SchemaBranchMixin],

  propTypes: {
    userPkCursor: BaobabPropTypes.cursor.isRequired,
    initialExpertCursor: BaobabPropTypes.cursor.isRequired,
    label: PropTypes.string,
  },

  schema: {
    search: '',
    isLoading: false,
    options: [],
  },

  cursors() {
    return {
      initialExpert: this.props.initialExpertCursor,
    }
  },

  getSelectOption() {
    const { options, initialExpert } = this.state
    if (options.length) {
      return options
    }

    if (initialExpert) {
      return [initialExpert]
    }

    return []
  },

  componentDidMount() {
    this.loadExperts()
  },

  loadExperts() {
    this.cursors.isLoading.set(true)

    expertApi.getList().then((results) => {
      const options = _.map(results, (item) => ({
        label: getFullName(item.user),
        value: item.pk,
      }))

      this.cursors.options.set(options)
      this.cursors.isLoading.set(false)
    })
  },

  render() {
    const { userPkCursor, label } = this.props
    const selectOptions = this.getSelectOption()

    return (
      <div>
        <label className="mb-2 block text-default-light">
          {label || <GetText>Choose expert</GetText>}
        </label>

        <Select
          cursor={userPkCursor}
          options={selectOptions}
          style={{ width: '100%' }}
          isLoading={this.cursors.isLoading.get()}
        />
      </div>
    )
  },
})
